import { Mail, Phone } from "lucide-react";

export const PortalMarco = ({ empresa, children }) => (
  <div className="min-h-screen bg-[#F4F7FA] font-['Montserrat',sans-serif] text-slate-800">
    <header className="bg-[#1B2B4B] border-b-4 border-[#00B4CC] sticky top-0 z-30">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <span className="w-10 h-8 rounded-lg bg-white flex items-center justify-center shrink-0"><img src="/nuvlipro-logo.png" alt="NuvliPro" className="h-6 object-contain" /></span>
          <span className="min-w-0"><span className="block text-white font-bold leading-tight">NuvliPro</span>
            <span className="block text-[10px] font-semibold tracking-[0.18em] text-[#00B4CC]">PORTAL DEL CLIENTE</span></span>
        </div>
        {empresa?.razon_social && <span className="text-xs text-white/75 truncate text-right" data-testid="portal-empresa">{empresa.razon_social}</span>}
      </div>
    </header>
    <main className="max-w-5xl mx-auto px-3 sm:px-4 py-5 sm:py-8 space-y-6">{children}</main>
    {empresa && (
      <footer className="max-w-5xl mx-auto px-4 pb-10 pt-2 text-xs text-slate-500 flex flex-wrap gap-x-5 gap-y-1">
        <span className="font-semibold text-slate-600">{empresa.razon_social}</span>
        {empresa.telefono && <a href={`tel:${empresa.telefono}`} className="inline-flex items-center gap-1 hover:text-[#0090A3]"><Phone className="w-3.5 h-3.5" /> {empresa.telefono}</a>}
        {empresa.email && <a href={`mailto:${empresa.email}`} className="inline-flex items-center gap-1 hover:text-[#0090A3]"><Mail className="w-3.5 h-3.5" /> {empresa.email}</a>}
      </footer>
    )}
  </div>
);

export const SeccionPortal = ({ id, icon: Icon, titulo, extra, children }) => (
  <section id={id} className="scroll-mt-24 animate-in fade-in slide-in-from-bottom-2 duration-500" data-testid={`portal-seccion-${id}`}>
    <div className="flex items-center justify-between gap-3 mb-3">
      <h2 className="flex items-center gap-2 text-base sm:text-lg font-bold text-[#1B2B4B]"><Icon className="w-5 h-5 text-[#00B4CC]" /> {titulo}</h2>
      {extra}
    </div>
    {children}
  </section>
);
